import { defaultProductionPagination } from '../../constants/consts';

export const GET_COMPANY_DATA = 'app/Company/GET_COMPANY_DATA';
export const GET_COMPANY_UNPUBLISHED_SEASON = 'app/Company/GET_COMPANY_UNPUBLISHED_SEASON';
export const GET_COMPANY_SEASONS_VALUES = 'app/Company/GET_COMPANY_SEASONS_VALUES';
export const GET_COMPANY_VENUES = 'app/Company/GET_COMPANY_VENUES';
export const GET_COMPANY_CONTACT = 'app/Company/GET_COMPANY_CONTACT';
export const ADD_AND_UPDATE_CONTACTS = 'app/Company/ADD_AND_UPDATE_CONTACTS';
export const SET_COMPANY = 'app/Company/SET_COMPANY';
export const UPDATE_COMPANY = 'app/Company/UPDATE_COMPANY';
export const GET_MUSICAL_WORKS_LIST = 'app/Company/GET_MUSICAL_WORKS_LIST';
export const GET_COMPANY_EDIT_SEASON = 'app/Company/GET_COMPANY_EDIT_SEASON';
export const GET_COMPANY_IMAGES = 'app/Company/GET_COMPANY_IMAGES';
export const GET_COMPANY_VIDEOS = 'app/Company/GET_COMPANY_VIDEOS';
export const SET_SEASONS = 'app/Company/SET_SEASONS';
export const CLEAR_EDIT_SEASONS = 'app/Company/CLEAR_EDIT_SEASONS';
export const GET_COMPANY_STAFF = 'app/Company/GET_COMPANY_STAFF';
export const UPDATE_COMPANY_INFO = 'app/Company/UPDATE_COMPANY_INFO';
export const UPDATE_COMPANY_VENUE = 'app/Company/UPDATE_COMPANY_VENUE';
export const GET_COMPANY_DESCRIPTIONS = 'app/Company/GET_COMPANY_DESCRIPTIONS';
export const CREATE_COMPANY_DESCRIPTION = 'app/Company/CREATE_COMPANY_DESCRIPTION';
export const UPDATE_COMPANY_DESCRIPTION = 'app/Company/UPDATE_COMPANY_DESCRIPTION';
export const DELETE_COMPANY_DESCRIPTION = 'app/Company/DELETE_COMPANY_DESCRIPTION';

export const PRODUCTIONS_TYPES = {
  published: 'published',
  unpublished: 'unpublished',
};

export const defaultCompanyProductionsPagination = defaultProductionPagination;
